<ng-container *ngIf="currentYear < retirementYear && contributionLevel !== 'transfer_only'; else hideSavings">
  <div class="box--white">
    <ion-row>
      <ion-col>
        <h2 (click)="openLegalInfo()">
          {{ (isStrategy ? 'sp.revamp.assetGraph.strategy.title' : 'sp.revamp.assetGraph.savings') | translate }}
          <ion-icon name="info-filled"></ion-icon>
        </h2>
        <div class="expected-box blue">
          <p class="title">
            {{ 'sp.revamp.3a.expected.total' | translate }}
            <app-tooltip [trigger]="'expected-title'">
              <span [class.lowercase]="!isGerman()">
                {{ 'sp.revamp.infoTooltip.balancedRiskGross' | translate:{risk_level: ('STRATEGY.estimate.risk.' + riskLevel | translate)}
                }}
              </span>
            </app-tooltip>
          </p>
          <p class="funds" *ngIf="estimatedValues?.expected">
            <span class="currency">{{customerInvestment.currency}}</span>
            {{ estimatedValues.expected.toFixed(0) | thousand }}
          </p>
        </div>
        <div class="expected-box">
          <p class="title">{{ 'sp.revamp.3a.deposits.total' | translate }}</p>
          <p class="funds">
            <span class="currency">{{customerInvestment.currency}}</span>
            {{ getTotalDeposit() | thousand }}
          </p>
        </div>
        <div class="strategy-chart">
          <app-range-chart-3a
            [data]="chartData"
            [estimatedValues]="estimatedValues"
            [expectedPercentages]="expectedPercentages"
            [currency]="customerInvestment.currency"
            [language]="language"
            [retirementYear]="retirementYear"
            [timeToRetirement]="timeToRetirement"
            [selectedChip]="selectedChip"
            (setChip)="setChip($event)"
          ></app-range-chart-3a>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-asset-deposit
          [appLocation]="appLocation"
          [currency]="customerInvestment?.currency"
          [newSavings]="customerInvestment?.monthly_investment"
          [inputError]="inputError"
          [kind]="currentAccount.kind"
          [maximumInput]="maximumInput"
          [minimumInput]="minimumInput"
          [selectedChip]="selectedChip"
          (changeValue)="onChangeValue($event)"
          (setDeposit)="onSetDeposit($event)"
        ></app-asset-deposit>
        <app-asset-social-proof
          [currency]="customerInvestment?.currency"
          [estimatedPeriod]="timeToRetirement"
          [estimatedValues]="estimatedValues"
          [expectedPercentages]="expectedPercentages"
          [kind]="currentAccount.kind"
          [savingsPlanSocialProof]="savingsPlanSocialProof"
          (toggleDetails)="track($event)"
        ></app-asset-social-proof>
      </ion-col>
    </ion-row>
  </div>
</ng-container>
<ng-template #hideSavings>
  <div class="info">
    <p class="title">
      <ion-icon name="info-filled"></ion-icon>
      <span>{{ 'depositDelayNote.title' | translate }}</span>
    </p>
    <p>
      {{ 'sp.revamp.3a.note.' + (contributionLevel === 'transfer_only' ? 'trasfer' :'retired') | translate}}
      <a (click)="contactSupport()">{{ 'depositDelayNote.link' | translate }}</a>
      .
    </p>
  </div>
</ng-template>
